import React from 'react';
import PropTypes from 'prop-types';

import { DayPickerRangeController as ReactDayPickerRangeController } from 'react-dates';

import * as Icons from '../icons/Icons';

const propTypes = {
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    focusedInput: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    onDatesChange: PropTypes.func.isRequired,
    onFocusChange: PropTypes.func.isRequired
};

const defaultProps = {
    startDate: null,
    endDate: null,
    focusedInput: 'endDate'
};

export default class DayPickerRangeController extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // Force the focusedInput to always be truthy so that dates are always selectable
            focusedInput: props.focusedInput || 'startDate'
        };
        this.onDatesChange = this.onDatesChange.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
    }

    onDatesChange({ startDate, endDate }) {
        this.props.onDatesChange({ startDate, endDate });
    }

    onFocusChange(focusedInput) {
        this.setState({
            // Force the focusedInput to always be truthy so that dates are always selectable
            focusedInput: !focusedInput ? "startDate" : focusedInput
        }, () => this.props.onFocusChange({ focusedInput }));
    }

    render() {
        const arrowIconBack = (<Icons.IconArrowBack className="rec-icon-arrow-back" />);
        const arrowIconForward = (<Icons.IconArrowForward className="rec-icon-arrow-forward" />);

        return (
            <ReactDayPickerRangeController
                {...this.props}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                onDatesChange={this.onDatesChange}
                focusedInput={this.state.focusedInput}
                onFocusChange={this.onFocusChange}
                navPrev={arrowIconBack}
                navNext={arrowIconForward} />
        );
    }
}

DayPickerRangeController.propTypes = propTypes;
DayPickerRangeController.defaultProps = defaultProps;
